import React from 'react';
import get from 'lodash/get';
import {Table} from 'semantic-ui-react';
import {FormattedMessage} from 'react-intl';
import {formatDate} from 'utils/DBUtils';

const WinnerPrizeHistory = props => (
  <Table striped>
    <Table.Header className='white-header'>
      <Table.HeaderCell>
        <FormattedMessage id='modal.winnerDetail.label.prize' />
      </Table.HeaderCell>
      <Table.HeaderCell>
        <FormattedMessage id='modal.winnerDetail.label.winDate' />
      </Table.HeaderCell>
      <Table.HeaderCell>
        <FormattedMessage id='modal.winnerDetail.label.forfeitDate' />
      </Table.HeaderCell>
    </Table.Header>
    <Table.Body>
      {props.prizeHistory.map(prizeEntry => (
        <Table.Row key={prizeEntry.id}>
          <Table.Cell className='prize-title'>{get(prizeEntry.prize, 'title', null)}</Table.Cell>
          <Table.Cell>{formatDate(prizeEntry.dateWon, 'MM/DD/YY')}</Table.Cell>
          <Table.Cell>{prizeEntry.forfeitDate ? formatDate(prizeEntry.forfeitDate, 'MM/DD/YY') : null}</Table.Cell>
        </Table.Row>
      ))}
    </Table.Body>
  </Table>
);

export default WinnerPrizeHistory;



// WEBPACK FOOTER //
// ./public/components/WinnerDetailModal/WinnerPrizeHistory.jsx